import * as PIXI from 'pixi.js'
import { Sprite, Assets } from 'pixi.js'

export default class objDeco {
    constructor(app, container) {
        this.app = app
        this.container = container

        this.decoSprites = []

        const decoitem = document.querySelectorAll('.js-ques-deco')
        this.deconum = decoitem.length
        this.decoon = Array.from({ length: this.deconum }, () => false)

        this.init()
    }

    init() {
        this.getDecoimg()
    }

    getDecoimg() {
        const decoitem = [...document.querySelectorAll('.js-ques-deco')]

        decoitem.forEach((el) => {
            el.addEventListener('click', () => {
                const deco = el.getAttribute('data-deco')

                const btnok = document.querySelector('.js-btn-paginate.-ok')
                btnok.classList.add('-active')

                el.classList.toggle('-active')
                
                this.toggleDeco(deco)
            })
        })
    }

    toggleDeco(deco) {
        const deconum = Number(deco)
        const decoindex = deconum - 1

        for (let i = 0; i <= this.deconum; i++) {
            if (deconum === i) {
                if (this.decoon[decoindex] === false) {
                    this.decoon[decoindex] = true
                    this.setDeco(deconum)
                } else {
                    this.decoon[decoindex] = false
                    this.removeDeco(deconum)
                }
            }
        }
    }

    resetbtn() {
        const decoitem = [...document.querySelectorAll('.js-ques-deco')]
        const deconum = decoitem.length

        for (let i = 1; i <= deconum; i++) {
            this.decoon[i] = false
        }
        decoitem.forEach((el) => {
            el.classList.remove('-active')
        })
    }

    removeDeco(id) {
        this.container.removeChild(this.decoSprites[id])
        delete this.decoSprites[id]
    }

    //推し設定でcontainer作成
    setContainer() {
        this.container = new PIXI.Container()
        this.container.sortableChildren = true
        this.app.stage.addChild(this.container)

        this.getDecoimg()
    }

    async setDeco(id) {
        const decoImage = await Assets.load(`/oshigatari/assets/img/generator/deco/ph_${id}.png`)

        this.decoSprites[id] = new Sprite(decoImage)
        this.decoSprites[id].width = this.app.renderer.width
        this.decoSprites[id].height = this.app.renderer.height
        this.decoSprites[id].zIndex = 0

        this.container.addChild(this.decoSprites[id])
    }

    //デコレーションがあれば削除する
    removeSprite() {
        const decoitem = [...document.querySelectorAll('.js-ques-deco')]
        const itemnum = decoitem.length

        for (let i = 0; i <= itemnum; i++) {
            this.removeDeco(i)
        }
    }
}
